import { api } from '@connected/api-client';
import { elektraAppQueryOptions } from '@connected/elektra-sdk/queries/query-options';

import { queryClient } from '@/lib/query-client';

export type ObservationLogStatusMutationParams = {
    electricalProjectVersionId: string;
};

export function useObservationLogStatusMutation({
    electricalProjectVersionId,
}: ObservationLogStatusMutationParams) {
    return api.useMutation('post', '/api/v2/electrical/projects/observations/logs/create', {
        onSettled: () => {
            queryClient.invalidateQueries(elektraAppQueryOptions.project.inspection.conclusion.observationLogsListOptions({
                electricalProjectVersionId,
            }));
        },
        scope: {
            id: electricalProjectVersionId,
        },
    });
}
